import { SvgIconProps } from '@mui/material'
import RotableProductIcon from '@mui/icons-material/ManageHistoryRounded'
import ConsumableProductIcon from '@mui/icons-material/SettingsRounded'
import ToolProductIcon from '@mui/icons-material/BuildRounded'
import OtherProductIcon from '@mui/icons-material/QuestionMarkRounded'

export type ProductType = 'ROTABLE' | 'CONSUMABLE' | 'TOOL' | 'OTHER'

interface ProductTypeIconProps extends SvgIconProps {
  variant: ProductType
  isRental?: boolean
}

const ProductTypeIcon = ({
  variant,
  isRental,
  ...props
}: ProductTypeIconProps) => {
  // TODO: Add rental indicator when design is provided
  switch (variant) {
    case 'ROTABLE':
      return <RotableProductIcon {...props} />
    case 'CONSUMABLE':
      return <ConsumableProductIcon {...props} />
    case 'TOOL':
      return <ToolProductIcon {...props} />
    case 'OTHER':
      return <OtherProductIcon {...props} />
  }
}

export default ProductTypeIcon
